export const splitPath = (parentPath = '/', path = '/') => {
    const nestedPath = `${parentPath.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
    return nestedPath;
};
